














import { Component, Mixins } from "vue-property-decorator";
import { IConfiguration } from "../../../../domain/configuration";
import { SessionStorageAccessor } from "../../../../store/SessionStorageAccessor";
import { ObjectUtility } from "../../../../utilities";
import JsonEditor from "../../../system/editors/JsonEditor.vue";

@Component({
  components: {
    JsonEditor,
  }
})
export default class ConfigurationEditor extends Mixins() {
  data(): any {
    return {
      source: null,
    };
  }
  source: IConfiguration;

  mounted(): void {
    this.source = ObjectUtility.copyDeeply(this.$store.getters.configuration);
  }

  apply(): void {
    this.applyStore();
    this.applySessionStorage();
  }

  applyStore(): void {
    this.$store.commit("setConfiguration", this.source);
  }

  applySessionStorage(): void {
    SessionStorageAccessor.configuration = this.source;
  }
}
